// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__cPUFj"};